import { checkIsObjectEmpty } from "features/Common/modules/DataTypes/utils/object";
import { MERGE_CONTACT_FORM_KEYS } from "../../constants/MergeContactFormModal.constant";
import { useMergeContactModalStore } from "../../store/useMergeContactModalStore";
import { useEffect } from "react";
import { isBefore } from "date-fns";

export const useMergeContact = () => {
  const selectedRecords = useMergeContactModalStore(
    (state) => state.selectedRecords
  );
  const setMergedContactDetails = useMergeContactModalStore(
    (state) => state.setMergedContactDetails
  );

  const fetchOptions = (fieldKey) => {
    if (selectedRecords && !checkIsObjectEmpty(selectedRecords)) {
      let options = [];
      Object.keys(selectedRecords).forEach((selectedRecordId) => {
        if (fieldKey === MERGE_CONTACT_FORM_KEYS.NAME) {
          options.push(selectedRecords?.[selectedRecordId]?.full_name);
        } else if (fieldKey === MERGE_CONTACT_FORM_KEYS.EMAIL_ID) {
          options.push(selectedRecords?.[selectedRecordId]?.email);
        } else if (fieldKey === MERGE_CONTACT_FORM_KEYS.PHONE_NUMBER) {
          options.push(selectedRecords?.[selectedRecordId]?.phone_number);
        }
      });
      return options;
    } else {
      return [];
    }
  };

  useEffect(() => {
    if (selectedRecords) {
      let olderRecord = {};
      Object.keys(selectedRecords).forEach((selectedRecordId) => {
        if (!olderRecord || checkIsObjectEmpty(olderRecord)) {
          olderRecord = selectedRecords?.[selectedRecordId];
        } else if (
          isBefore(
            new Date(olderRecord.lead_created_at),
            new Date(selectedRecords?.[selectedRecordId].lead_created_at)
          )
        ) {
          olderRecord = selectedRecords?.[selectedRecordId];
        }
      });
      if (olderRecord && !checkIsObjectEmpty(olderRecord)) {
        setMergedContactDetails(
          MERGE_CONTACT_FORM_KEYS.NAME,
          olderRecord.full_name
        );
        setMergedContactDetails(
          MERGE_CONTACT_FORM_KEYS.EMAIL_ID,
          olderRecord.email
        );
        setMergedContactDetails(
          MERGE_CONTACT_FORM_KEYS.PHONE_NUMBER,
          olderRecord.phone_number
        );
      }
    }
  }, [selectedRecords]);

  return {
    fetchOptions,
  };
};
